export const STATUS_LABELS = {all:'전체 상태',provided:'제공 중',mine:'내 등급 이용 가능',locked:'상위 등급 필요',unavailable:'현재 미제공'};

export function filterAnalyses(items, state, favorites = [], authority = 0) {
  const words = String(state.query || '').trim().toLowerCase().split(/\s+/).filter(Boolean);
  return items.filter(item => {
    if (state.section === 'favorites' && !favorites.includes(item.url)) return false;
    if (state.group && item.group !== state.group) return false;
    if (state.category && item.category !== state.category) return false;
    if (!words.every(word => item.search.includes(word))) return false;
    if (state.status === 'provided') return !item.unavailable;
    if (state.status === 'unavailable') return item.unavailable;
    if (state.status === 'mine') return !item.unavailable && authority >= item.authorityLevel;
    if (state.status === 'locked') return !item.unavailable && authority < item.authorityLevel;
    return true;
  });
}

export function parseExploreRoute(route) {
  const query = route.query || {};
  const value = key => typeof query[key] === 'string' ? query[key] : '';
  const category = ['all','realestate','economy'].includes(value('category')) ? value('category') : route.name === 'economy' ? 'economy' : '';
  const status = Object.prototype.hasOwnProperty.call(STATUS_LABELS,value('status')) ? value('status') : 'all';
  return {
    query:value('q'),
    category:category === 'all' ? '' : category,
    group:value('group'),
    status,
    layout:value('layout') === 'grid' ? 'grid' : 'list',
    section:value('view') === 'favorites' ? 'favorites' : value('view') === 'all' || value('q') || value('group') || status !== 'all' ? 'all' : 'home'
  };
}

export function exploreQuery(state) {
  const result = {};
  if (state.query.trim()) result.q = state.query;
  if (state.section !== 'home') result.view = state.section;
  // Explicit "all" also restores all categories on the /economy route.
  result.category = state.category || 'all';
  if (state.group) result.group = state.group;
  if (state.status !== 'all') result.status = state.status;
  // Keep both explicit modes in shared/return URLs when the default changes.
  result.layout = state.layout === 'grid' ? 'grid' : 'list';
  return result;
}

export function cataloguePath(state, routeName) {
  const path = routeName === 'economy' ? '/economy' : '/realestate';
  const query = exploreQuery(state);
  return path + '?' + Object.keys(query).map(key => encodeURIComponent(key)+'='+encodeURIComponent(query[key])).join('&');
}
